<div class="welcome">
  <div class="po-row welcome-salutation">
    <div class="po-xl-8 po-lg-8 po-md-6 po-sm-4 display-desktop">
      <img class="logo-desktop" [src]="imagePath">
      <div class="po-font-text-bold welcome-line">Minhas Operações - Bem-vindo</div>
      <div class="po-font-text welcome-line"><span>{{ newSalutation }}</span></div>
    </div>
    <div class="po-xl-8 po-lg-8 po-md-6 po-sm-1 display-mobile">
      <img class="logo-mobile" [src]="imagePath">
      <span class="po-font-text-bold welcome-line-mobile">Minhas Operações</span>
    </div>

    <div *ngIf="!displayFilter" class="po-xl-4 po-lg-4 po-md-6 po-sm-11 welcome-action">
      <span class="po-ml-2 po-clickable po-icon po-icon-refresh po-pl-2" *ngIf="routerName != 'sales-filial' && routerName != 'sales-group' && routerName != 'sales-sallers' && routerName != 'selling-products' && routerName != 'pedding-conditionals' && routerName != 'sales-record-detail' && refreshButtonDisabled" p-tooltip="Recarregar" (click)="refreshFilter()"></span>
      <span class="po-ml-2 po-clickable po-icon po-icon-parameters po-pl-2" *ngIf="routerName != 'sales-filial' && routerName != 'sales-group' && routerName != 'sales-sallers' && routerName != 'selling-products' && routerName != 'pedding-conditionals'" && routerName != 'sales-record-detail' style="border-left: 1px solid white;" p-tooltip="Filtros" (click)="toggleFilters()"></span>
      <span #config class="po-ml-2 po-clickable po-icon po-icon-settings po-pl-2" style="border-left: 1px solid white;" p-tooltip="Ferramentas" (click)="popupconfig.toggle()"></span>
      <span *ngIf="moduleVisible" class="po-ml-2 po-clickable po-icon po-icon-stock po-pl-2" style="border-left: 1px solid white;" p-tooltip="Módulos" (click)="goModulos()"></span>
      <span #target class="po-ml-2 po-clickable po-icon po-icon-user po-pl-2" style="border-left: 1px solid white;" p-tooltip="Usuário" (click)="popup.toggle()">
      </span>
      <po-popup #popup [p-actions]="actions" [p-target]="target"> </po-popup>
      <po-popup #popupconfig [p-actions]="actionsConfigs" [p-target]="config"> </po-popup>
    </div>
  </div>
  <div id="log" class="dont-show-log">
    <div class="po-row">
      <div class="po-xl-12 po-lg-12 po-md-12 po-sm-12 po-p-2">
        <span><b>Ativar rastreamento de informação log:</b></span>
        <br>
        <span class="po-mt-6">
          1. Ative o rastreamento de informação log para obter o arquivo log solicitado pelo suporte:
        </span>
        <div class="po-xl-12 po-lg-12 po-md-12 po-sm-12 po-text-center" id="button-log">
          <po-switch
            name="serviceRastreamento"
            [(ngModel)]="serviceRastreamento"
            p-label-off="Rastreamento Desligado"
            p-label-on="Rastreamento Ligado"
            (p-change)="addServiceRastreamento()"
          >
          </po-switch>
          <span></span>
        </div>
        <br>
        <span>
          2. Após a ativação realize a operação desejada para obter o rastreio do log;
        </span>
        <br>
        <span>
          3. Faça o download do arquivo abaixo e encaminhe para o suporte:
        </span>
        <div *ngIf="!exibeDownload" class="po-xl-12 po-lg-12 po-md-12 po-sm-12 po-p-1 po-text-center log-download">
          <span>O rastreamento de log não está ativo!</span>
        </div>
        <div *ngIf="exibeDownload" class="po-row po-p-1 log-download">
          <div class="po-xl-12 po-lg-12 po-md-12 po-sm-12 po-text-center">
            <span>arquivo-log.txt</span>
          </div>
          <div class="po-xl-12 po-lg-12 po-md-12 po-sm-12 po-text-center po-mb-1" id="button-log-download">
            <po-button (p-click)="saveFile()" p-label="Download"></po-button>
          </div>
        </div>
      </div>
    </div>
    <hr>
  </div>
  <div class="dont-show-filter">
    <app-filter (filterClick)="filterChange($event)"></app-filter>
  </div>
</div>
